import Header from '../Header.js';
import dynamicImageImporter from '../../utils/dynamicImageImporter.js';
import { SocialIcon } from 'react-social-icons/component';
import './BottomHeader.css';

const staticImages = dynamicImageImporter(require.context('/public/art/static', false));
const instagramUrl = "https://www.instagram.com/bluehoneystudios/";
const youtubeUrl = "https://www.youtube.com/channel/UCPvDTlNXcQBH8lqlEYEJ6rQ";

function BottomHeader(){
    return(
        <div className="BottomHeader-Container">
            <BottomBackground />
            <div className="BottomHeader-TextContainer">
                <SocialSection />
                <Copyright />
            </div>
        </div>    
    );
}

function BottomBackground()
{
  return(
    <img src={staticImages['mushroomBg']} className="BottomHeader-Background" alt="ImpureArenaBanner"/>
  ) 
}

function SocialSection()
{
    return(
        [
            <div className="BottomHeader-Social-Container">
                <SocialIcon url={youtubeUrl} bgColor="#FFD500" fgColor='#000000ff' className="BottomHeader-SocialIcon" style={{ height: 50, width: 50 }}/>
                <SocialIcon url={instagramUrl} bgColor="#FFD500" fgColor='#000000ff' className="BottomHeader-SocialIcon" style={{ height: 50, width: 50 }}/>
            </div>
        ]
    );
}

function Copyright()
{
    return(
        <Header className="BottomHeader-Copyright" text="© Blue Honey Studios 2025 - All rights reserved."/>
    );
}

export default BottomHeader;